import { PROJECTS_ENDPOINT } from "Constants";
import { baseApi } from "Services";
import { MoveFileToProjectRequest, MoveFileToProjectResponse } from "../types";

export const moveToProjectApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    moveFileToProject: builder.mutation<
      MoveFileToProjectResponse,
      MoveFileToProjectRequest
    >({
      query: (queryArg) => ({
        url: `${PROJECTS_ENDPOINT}/projects/move-file-to-projects`,
        params: {
          force: queryArg.force,
          replace: queryArg.replace,
          notify_on_completion: queryArg.notify_on_completion,
        },
        method: "POST",
        body: queryArg.body,
      }),
      invalidatesTags: [{ type: "Files", id: "LIST" }, "Usage"],
    }),
  }),
  overrideExisting: false,
});

export const { useMoveFileToProjectMutation } = moveToProjectApi;
